export default {
    path: 'menu',
    component: () => import('../Menu.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách menu',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo menu',
            component: () => import('../cu/CU.vue')
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa menu',
            component: () => import('../cu/CU.vue')
        },
    ]
};